module.exports = __webpack_public_path__ + "img/icon_logo_lang_middle.278ca16d.png";